// @flow
import React, { Component } from 'react';
import { withRouter } from 'common/components/core/router';
import { connect } from 'react-redux';

import { AsyncMultiSelectFilter } from 'common/components/core/select';

import RiderPersonaActions from 'common/redux/actions/riderPersona';
import RiderPersonaSelectors from 'common/redux/selectors/riderPersona';
import { clientSelector } from 'common/redux/selectors/queryParamsSelectors';
import type { RiderPersona } from 'common/models/flow/MasterRiderPersona';

type Props = {
    fetchRiderPersonas: Function,
    clientId: string,
    riderPersonas: Array<RiderPersona>
};
class RiderPersonaFilter extends Component<Props> {
    fetchFilteredRiderPersonas = filters => {
        this.props.fetchRiderPersonas(
            { clientId: this.props.clientId },
            { filters }
        );
    };

    getOptionLabelValue = (option: RiderPersona): string => option.id;

    render() {
        const { riderPersonas = [], ...rest } = this.props;
        return (
            <AsyncMultiSelectFilter
                {...rest}
                options={riderPersonas}
                getOptionValue={this.getOptionLabelValue}
                getOptionLabel={this.getOptionLabelValue}
                fetchFilteredOptions={this.fetchFilteredRiderPersonas}
                filterOptionsBasedOn="id"
            />
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    const clientId = clientSelector(state, ownProps);
    const riderPersonas = RiderPersonaSelectors.getEntities(state, ownProps);
    return {
        riderPersonas: riderPersonas?.entities,
        clientId
    };
};

const ConnectedRiderPersonaSelectorFilter = withRouter(
    connect(mapStateToProps, {
        fetchRiderPersonas: RiderPersonaActions.fetchActiveEntities
    })(RiderPersonaFilter)
);

export default ConnectedRiderPersonaSelectorFilter;
